import React from "react";
import moment from "../../../../../moment";
import { DATE_SHORT_FORMAT } from "../../../../../components/DatePicker";
import Tooltip from "../../../../../components/Tooltip";

export const createDisabledDateBefore = (form, fieldName) => (current) => {
  const periodTo = form.getFieldValue(fieldName);
  return periodTo
    ? moment(current, DATE_SHORT_FORMAT).startOf("day") > moment(periodTo, DATE_SHORT_FORMAT).startOf("day")
    : false;
};

export const createDisabledDateAfter = (form, fieldName) => (current) => {
  const periodFrom = form.getFieldValue(fieldName);
  return periodFrom
    ? moment(current, DATE_SHORT_FORMAT).startOf("day") < moment(periodFrom, DATE_SHORT_FORMAT).startOf("day")
    : false;
};

export const getOptionalDateTooltip = (t) => (
  <Tooltip title={t("container.general_words.not_required_date")}>
    <i className="ti-info-alt absolute-vertical-center datepicker-tooltip" />
  </Tooltip>
);
